import { Box, Divider, Typography } from '@mui/material';
import Grid from '@mui/material/Grid';

import LlmEndpointField from './LlmEndpointField';
import LlmModelFamilyField from './LlmModelFamilyField';
import VllmEndpointField from './VllmEndpointField';
import VllmModelFamilyField from './VllmModelFamilyField';
import EmbeddingEndpointField from './EmbeddingEndpointField';
import VdbEndpointField from './VdbEndpointField';
import type { OrganizationUpdateRequest } from '@/actions/org';

interface ModelsFieldsProps {
  values: OrganizationUpdateRequest;
  setValue: <K extends keyof OrganizationUpdateRequest>(
    key: K,
    value: OrganizationUpdateRequest[K],
  ) => void;
  setChanged: () => void;
  errors: Partial<Record<keyof OrganizationUpdateRequest, string>>;
}

function ModelsFields({
  values,
  setValue,
  setChanged,
  errors,
}: ModelsFieldsProps): React.JSX.Element {
  return (
    <Box sx={{ width: '100%' }}>
      <Typography variant='h6' sx={{ mt: 3 }}>
        Models
      </Typography>
      <Divider sx={{ my: 2 }} />

      <Grid container spacing={2}>
        <Grid size={12}>
          <LlmEndpointField
            value={values.llm_endpoint ?? ''}
            error={errors.llm_endpoint}
            setValue={(v) => {
              setValue('llm_endpoint', v);
              setChanged();
            }}
          />
        </Grid>
        <Grid size={{ xs: 12, md: 6 }}>
          <LlmModelFamilyField
            value={values.llm_model_family ?? null}
            setValue={(v) => {
              setValue('llm_model_family', v);
              setChanged();
            }}
          />
        </Grid>
        <Grid size={12}>
          <VllmEndpointField
            value={values.vllm_endpoint ?? ''}
            error={errors.vllm_endpoint}
            setValue={(v) => {
              setValue('vllm_endpoint', v);
              setChanged();
            }}
          />
        </Grid>
        <Grid size={{ xs: 12, md: 6 }}>
          <VllmModelFamilyField
            value={values.vllm_model_family ?? null}
            setValue={(v) => {
              setValue('vllm_model_family', v);
              setChanged();
            }}
          />
        </Grid>
        <Grid size={12}>
          <EmbeddingEndpointField
            value={values.embedding_endpoint ?? ''}
            error={errors.embedding_endpoint}
            setValue={(v) => {
              setValue('embedding_endpoint', v);
              setChanged();
            }}
          />
        </Grid>
        <Grid size={12}>
          <VdbEndpointField
            value={values.vdb_endpoint ?? ''}
            error={errors.vdb_endpoint}
            setValue={(v) => {
              setValue('vdb_endpoint', v);
              setChanged();
            }}
          />
        </Grid>
      </Grid>
    </Box>
  );
}

export default ModelsFields;

